















  const ExcelJS = require('exceljs')

  import { Component, Watch, Vue } from 'vue-property-decorator'
  import { mapState } from 'vuex'
  import { BPagination } from 'bootstrap-vue'
  import Header from '@/components/Header.vue'
  import EntityTabs from '@/components/EntityTabs.vue'
  import MemberSearch from '@/components/report/MemberSearch.vue'
  import ListView from '@/components/report/MemberList.vue'
  import { GapReportFilter } from '@/store/modules/types'
  import App from '@/App.vue'

  @Component({
    components: {
      BPagination,
      Header,
      EntityTabs,
      MemberSearch,
      /*     Pager,
    CalendarView, */
      ListView
    },
    computed: {
      ...mapState('gaps', ['filter'])
      /*  ...mapState("schedule", ["view", "list"]), */
      /*getDefaulthCampaign: function () {
      return this.$store.state.gaps.campaigns[0].id;
    },*/
    }
  })
  export default class MembersReport extends Vue {
    campaignId: string = ''
    filter!: GapReportFilter
    pageRows: Array<any> = []
    @Watch('filter', { deep: true })
    onFilterChanged() {
      //this.getReport();
    }

    defaultFilter(): GapReportFilter {
      return {
        insurerList: [],
        ipaList: [],
        priorityList: [],
        statusList: [],
        subStatusList: [],
        admissionDischargeList: [],
        referenceDate: {
          to: null,
          from: null
        },
        createdDate: {
          to: null,
          from: null
        },
        updated: {
          to: null,
          from: null
        },
        campaignId: this.getDefaulthCampaign.id,
        ownerUserList: []
      }
    }

    async getReport() {
      this.$store.commit('main/SET_LOADING', true)
      const { campaignId } = this.filter
      try {
        const data = await this.$store.dispatch('gaps/getMembersReport', campaignId)
        this.pageRows = data
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('main/SET_LOADING', false)
      }
    }

    get getDefaulthCampaign() {
      return this.$store.state.gaps.campaigns[0]
    }

    get getCampaignSelected() {
      return this.$store.state.gaps.campaigns.filter(c => c.id === this.filter.campaignId)[0]
    }

    get getEntity() {
      return this.$store.state.auth.user.entities.filter(e => e.id == this.$store.state.auth.entityId)[0]
    }

    // Función auxiliar para cargar la imagen y convertirla a Base64 sin bloquear el flujo principal
private loadImageToBase64(path: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.height = img.height;
      canvas.width = img.width;
      ctx?.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };
    img.onerror = (err) => reject(err);
    img.src = path;
  });
}

async exportExcel() {
  try {
    // 1. Activar estado de carga si es necesario
    this.$store.commit("main/SET_LOADING", true);

    const reportTitle = 'MEMBERS REPORT';
    const subtitle = this.getCampaignSelected?.name || '';
    const fileName = `members_report_dateFrom_${this.$moment().format('MMDDYYYY_hhmma')}`;
    const reportDate = this.$moment().format('MMM DD YYYY hh:mm A').toUpperCase();
    const medicalOffice = this.getEntity?.name || '';
    const moment = this.$moment;

    const header = [
      'Insurer', 'Member ID', 'Member Name', 'PCP NPI', 'PCP Name', 'Sex', 'Birthdate',
      'Task ID', 'Task', 'Stage', 'Status', 'Status Contact', 'Status Reason', 'Call Status',
      'Reference Date', 'Status in Program', 'Evaluation Date', 
      'Last Comment 1', 'Last Comment 2', 'Last Comment 3', 'Last Comment 4', 
      'Owner', 'Created', 'Updated'
    ];

    const font = { name: 'Calibri', family: 2, size: 16, underline: false, bold: true };
    const alignment = { vertical: 'middle', horizontal: 'right' };

    // 2. Mapear filas de datos de forma limpia usando .map()
    const data = this.pageRows.map((member: any) => [
      member.Insurer,
      member.MemberID,
      member.MemberName,
      member.PCPNPI,
      member.PCPName,
      member.Sex,
      member.Birthdate ? (this.$moment(member.Birthdate) as any).format('MM/DD/YYYY') : '',
      member.GapID,
      member.Measure,
      member.Stage,
      member.Status,
      member.StatusContact,
      member.StatusReason,
      member.SubStatus,
      member.ReferenceDate ? (this.$moment(member.ReferenceDate) as any).format('MM/DD/YYYY') : '',
      member.AdmisionDischarge,
      member.EvaluationDate ? (this.$moment(member.EvaluationDate) as any).format('MM/DD/YYYY') : '',
      member.Comment1 ? `${member.Comment1}|${member.CommentUserName1}` : '',
      member.Comment2 ? `${member.Comment2}|${member.CommentUserName2}` : '',
      member.Comment3 ? `${member.Comment3}|${member.CommentUserName3}` : '',
      member.Comment4 ? `${member.Comment4}|${member.CommentUserName4}` : '',
      member.Owner,
      member.Created ? (this.$moment(member.Created) as any).format('MMM DD, YYYY hh:mm A') : '',
      member.Updated ? (this.$moment(member.Updated) as any).format('MMM DD, YYYY hh:mm A') : ''
    ]);

    // 3. Inicializar Workbook de ExcelJS
    const workbook = new ExcelJS.Workbook();
    workbook.creator = 'PatientCare';
    workbook.lastModifiedBy = 'PatientCare';
    workbook.created = new Date();
    workbook.modified = new Date();
    workbook.lastPrinted = new Date();

    const worksheet = workbook.addWorksheet('Report');

    // 4. Agregar títulos y metadatos (Columna H)
    const metadataCells = ['H1', 'H2', 'H3', 'H4'];
    worksheet.getCell('H1').value = reportTitle;
    worksheet.getCell('H2').value = reportDate;
    worksheet.getCell('H3').value = medicalOffice;
    worksheet.getCell('H4').value = ''; // reportRangeDate si aplica

    worksheet.mergeCells('H1:I1');
    worksheet.mergeCells('H2:I2');
    worksheet.mergeCells('H3:I3');
    worksheet.mergeCells('H4:I4');

    metadataCells.forEach(ref => {
      const cell = worksheet.getCell(ref);
      cell.font = font;
      cell.alignment = alignment;
    });

    // 5. Cargar y añadir Logo de forma asíncrona
    try {
      const logoPath = require('../assets/wmpc_logo.png');
      const base64Data = await this.loadImageToBase64(logoPath);
      const logo = workbook.addImage({ base64: base64Data, extension: 'png' });
      worksheet.addImage(logo, 'A1:B4');
      worksheet.mergeCells('A1:B4');
    } catch (imageError) {
      console.error("No se pudo cargar el logo en el Excel:", imageError);
    }

    // Fila en blanco
    worksheet.addRow([]);

    // 6. Subtítulo (Campaña)
    const subTitleRow = worksheet.addRow([subtitle]);
    worksheet.mergeCells(`A6:I6`);
    subTitleRow.eachCell((cell) => {
      cell.border = { top: { style: 'thin', color: { argb: '87CEEB' } } };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.font = { size: 14, color: { argb: '000000' }, bold: true };
    });

    // 7. Fila de Encabezados (Headers)
    const headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '87CEEB' },
        bgColor: { argb: 'FFFFFF' }
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      cell.font = { size: 12, color: { argb: '000000' }, bold: true };
    });

    // 8. Agregar los datos mapeados
    worksheet.addRows(data);

    // 9. Configurar anchos y alineaciones de columnas de manera eficiente
    const columnWidths: { [key: number]: number } = {
      1: 30, 2: 30, 3: 30, 4: 16, 5: 30, 6: 16, 7: 30, 8: 30, 9: 60,
      11: 30,12: 30, 13: 20, 14: 20, 15: 20, 16: 20, 17: 20, 18: 20, 19: 20,
      20: 60, 21: 60, 22: 30, 23: 30, 24: 30
    };
    Object.keys(columnWidths).forEach((colIndex) => {
      worksheet.getColumn(Number(colIndex)).width = columnWidths[Number(colIndex)];
    });

    // ALINEACIÓN IZQUIERDA: Columna 8 (Task ID) y Columna 9 (Task)
    worksheet.getColumn(8).alignment = { horizontal: 'left', vertical: 'middle' };
    worksheet.getColumn(9).alignment = { horizontal: 'left', vertical: 'middle' };

    // 10. Construcción del Footer
    const footerFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' } };
    const footerStyles = (row: any) => {
      row.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${row.number}:I${row.number}`);
      row.eachCell((cell: any) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.font = { size: 12, color: { argb: '000000' }, bold: true };
      });
    };

    worksheet.addRow([]); // Fila vacía
    
    const fRow1 = worksheet.addRow([`Total: ${data.length} Members`]);
    footerStyles(fRow1);

    const fRow2 = worksheet.addRow(['service@waitingmed.com · www.waitingmed.com']);
    footerStyles(fRow2);

    const fRow3 = worksheet.addRow(['15105 D John Delaney Drive Suite 317, Charlotte NC 28277']);
    footerStyles(fRow3);

    worksheet.addRow([]); // Fila vacía final

    // 11. Descarga del archivo
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    
    const doc = document.createElement('a');
    doc.href = url;
    doc.download = `${fileName}.xlsx`;
    doc.click();
    
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error generando el reporte de Excel:", error);
  } finally {
    this.$store.commit("main/SET_LOADING", false);
  }
}

    exportExcelBK() {
      /*const store = this.$store;
    this.$store.commit("main/SET_LOADING", true);*/
      var reportTitle = 'MEMBERS REPORT'
      var subtitle = this.getCampaignSelected.name
      var fileName = 'members_report_dateFrom_' + this.$moment().format('MMDDYYYY_hhmma')
      const reportDate = this.$moment()
        .format('MMM DD YYYY hh:mm A')
        .toUpperCase()
      const reportRangeDate = ''
      /*"FROM " +
      this.$moment().format("MM/DD/YYYY") +
      " TO " +
      this.$moment().format("MM/DD/YYYY");*/
      const medicalOffice = this.getEntity.name
      //const calendar = this.report[0].Calendar.toUpperCase();
      // const waitingList = this.report[0].WaitingList.toUpperCase();
      const header = [
        'Insurer',
        'Member ID',
        'Member Name',
        /*"Group Number",
      "Group Name",
      "IPA Number",
      "IPA Name",*/
        'PCP NPI',
        'PCP Name',
        'Sex',
        'Birthdate',

        'Task ID',
        'Task',

        'Stage',
        'Status',
        'Status Contact',
        'Status Reason',
        'Call Status',
        'Reference Date',
        'Status in Program',
        /*"Date Admission",
      "Date Discharge",*/
        'Evaluation Date',
        'Last Comment 1',
        'Last Comment 2',
        'Last Comment 3',
        'Last Comment 4',
        'Owner',
        'Created',
        'Updated'
      ]
      const font = {
        name: 'Calibri',
        family: 2,
        size: 16,
        underline: false,
        bold: true
      }
      const alignment = {
        vertical: 'middle',
        horizontal: 'right'
      }
      const data: any = []
      var total = 0
      const moment: any = this.$moment
      for (const member of this.pageRows) {
        var row: any = []
        row.push(member.Insurer)
        row.push(member.MemberID)
        row.push(member.MemberName)
        /* row.push(member.GroupNumber);
      row.push(member.GroupName);
      row.push(member.IPANumber);
      row.push(member.IPAName);*/
        row.push(member.PCPNPI)
        row.push(member.PCPName)
        row.push(member.Sex)
        row.push(moment(member.Birthdate).format('MM/DD/YYYY'))

        row.push(member.GapID);
      row.push(member.Measure);

        row.push(member.Stage)
        row.push(member.Status)
        row.push(member.StatusContact)
        row.push(member.StatusReason)
        row.push(member.SubStatus)
        row.push(moment(member.ReferenceDate).format('MM/DD/YYYY'))
        row.push(member.AdmisionDischarge)
        /*row.push(member.DateAdmission?moment(member.DateAdmission).format("MM/DD/YYYY"):"");
      row.push(member.DateDischarge?moment(member.DateDischarge).format("MM/DD/YYYY"):"");*/
        row.push(member.EvaluationDate ? moment(member.EvaluationDate).format('MM/DD/YYYY') : '')
        row.push(member.Comment1 ? member.Comment1 + '|' + member.CommentUserName1 : '')
        row.push(member.Comment2 ? member.Comment2 + '|' + member.CommentUserName2 : '')
        row.push(member.Comment3 ? member.Comment3 + '|' + member.CommentUserName3 : '')
        row.push(member.Comment4 ? member.Comment4 + '|' + member.CommentUserName4 : '')
        
        row.push(member.Owner)
        row.push(moment(member.Created).format('MMM DD, YYYY hh:mm A'))
        row.push(member.Updated? moment(member.Updated).format('MMM DD, YYYY hh:mm A'):'')
        data.push(row)
      }
      //Create workbook and worksheet
      const workbook = new ExcelJS.Workbook()
      workbook.creator = 'PatientCare'
      workbook.lastModifiedBy = 'PatientCare'
      workbook.created = new Date()
      workbook.modified = new Date()
      workbook.lastPrinted = new Date()

      const worksheet = workbook.addWorksheet('Report')

      //Add Row and formatting
      let reportTitleRow = (worksheet.getCell('H1').value = reportTitle)
      let reportDateRow = (worksheet.getCell('H2').value = reportDate)
      let medicalOfficeRow = (worksheet.getCell('H3').value = medicalOffice)
      let reportRangeDateRow = (worksheet.getCell('H4').value = reportRangeDate)

      // Set font, size and style in title row.
      worksheet.mergeCells('H1:I1')
      worksheet.mergeCells('H2:I2')
      worksheet.mergeCells('H3:I3')
      worksheet.mergeCells('H4:I4')

      worksheet.getCell('H1').font = font
      worksheet.getCell('H2').font = font
      worksheet.getCell('H3').font = font
      worksheet.getCell('H4').font = font

      worksheet.getCell('H1').alignment = alignment
      worksheet.getCell('H2').alignment = alignment
      worksheet.getCell('H3').alignment = alignment
      worksheet.getCell('H4').alignment = alignment

      //Add logo
      var img = new Image()

      img.onload = function() {
        var canvas: any = document.createElement('CANVAS')
        var ctx = canvas.getContext('2d')
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(this, 0, 0)
        var dataURL = canvas.toDataURL('image/png')
        canvas = null

        //Add Image
        let logo = workbook.addImage({
          base64: dataURL,
          extension: 'png'
        })

        worksheet.addImage(logo, 'A1:B4')
        worksheet.mergeCells('A1', 'B4')

        // Blank Row
        worksheet.addRow([])

        //Add waitingList row
        let subTitleRow = worksheet.addRow([subtitle]) //subtitle
        worksheet.mergeCells('A6:I6')

        subTitleRow.eachCell((cell, number) => {
          cell.border = {
            top: {
              style: 'thin',
              color: {
                argb: '87CEEB'
              }
            }
          }

          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center'
          }

          cell.font = {
            size: 14,
            color: {
              argb: '000000'
            },
            bold: true
          }
        })

        //Add Header Row
        let headerRow = worksheet.addRow(header)

        // Cell Style : Fill and Border
        headerRow.eachCell((cell, number) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {
              argb: '87CEEB'
            },
            bgColor: {
              argb: 'FFFFFF'
            }
          }
          cell.border = {
            top: {
              style: 'thin'
            },
            left: {
              style: 'thin'
            },
            bottom: {
              style: 'thin'
            },
            right: {
              style: 'thin'
            }
          }

          cell.font = {
            size: 12,
            color: {
              argb: '000000'
            },
            bold: true
          }
        })

        //add data
        worksheet.addRows(data)

        //column width
        worksheet.getColumn(1).width = 30
        worksheet.getColumn(2).width = 30
        worksheet.getColumn(3).width = 60
        worksheet.getColumn(4).width = 16
        worksheet.getColumn(5).width = 30
        worksheet.getColumn(6).width = 16
        worksheet.getColumn(7).width = 30
        worksheet.getColumn(8).width = 30
        worksheet.getColumn(9).width = 60
        worksheet.getColumn(10).width = 40
        worksheet.getColumn(11).width = 40
        worksheet.getColumn(12).width = 60
        worksheet.getColumn(13).width = 40
        worksheet.getColumn(14).width = 40
        worksheet.getColumn(15).width = 40
        worksheet.getColumn(16).width = 40
        worksheet.getColumn(17).width = 40
        worksheet.getColumn(18).width = 40
        worksheet.getColumn(19).width = 40
        worksheet.getColumn(20).width = 60
        worksheet.getColumn(21).width = 60
        worksheet.getColumn(22).width = 60
        worksheet.getColumn(23).width = 60
        worksheet.getColumn(24).width = 60

        //Footer Row
        const footerFill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {
            argb: 'FFFFFF'
          }
        }

        var emptyRow = worksheet.addRow([])
        worksheet.mergeCells(`A${emptyRow.number}:I${emptyRow.number}`)

        let footerRow = worksheet.addRow(['Total: ' + data.length + ' Members'])
        footerRow.getCell(1).fill = footerFill
        worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`)

        footerRow.eachCell((cell, number) => {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center'
          }

          cell.font = {
            size: 12,
            color: {
              argb: '000000'
            },
            bold: true
          }
        })

        footerRow = worksheet.addRow(['service@waitingmed.com · www.waitingmed.com'])
        footerRow.getCell(1).fill = footerFill
        worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`)

        footerRow.eachCell((cell, number) => {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center'
          }

          cell.font = {
            size: 12,
            color: {
              argb: '000000'
            },
            bold: true
          }
        })

        footerRow = worksheet.addRow(['15105 D John Delaney Drive Suite 317,Charlotte NC 28277'])
        footerRow.getCell(1).fill = footerFill
        worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`)

        footerRow.eachCell((cell, number) => {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center'
          }

          cell.font = {
            size: 12,
            color: {
              argb: '000000'
            },
            bold: true
          }
        })

        emptyRow = worksheet.addRow([])
        worksheet.mergeCells(`A${emptyRow.number}:I${emptyRow.number}`)
        //save
        workbook.xlsx.writeBuffer().then(data => {
          let blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          //app.saveAs(blob, fileName + '.xlsx');
          var url = window.URL.createObjectURL(blob)

          var doc = document.createElement('a')
          doc.href = url
          doc.download = fileName + '.xlsx'
          doc.click()
          window.URL.revokeObjectURL(url)
        })
      }

      img.src = require('../assets/wmpc_logo.png')
    }

    clearFilter() {
      this.filter = this.defaultFilter()
      this.$store.commit('gaps/RESET_FILTER')
      this.getReport()
    }

    mounted() {
      this.getReport()
    }
  }
